import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { useTranslation } from "react-i18next";
import { mutate } from "swr";
import { useSnapshot } from "valtio";

import { store } from "../DefaultModalContentWrapper/store";
import { store as globalStore } from "@components/VerticalLayout/store";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import ErrorToast from "@components/Common/ErrorTost";
import { checkFavoriteConditions } from "./helpers";
import { DefaultSettingModal } from "..";
import { fetchGlobal } from "../../../../api/hooks";

import "./index.css";

type PropsType = {
    children: React.ReactNode;
    setIsConfigurationModalOpened: Function;
    isConfigurationModalOpened: boolean;
    setIsLoading: Function;
    numberClick: any;
    setNumberClick: any;
    setLimit: any;
    setIsModalLoadingOpened: Function;
    setModalLoadingData: Function;
};

export function DefaultModalWrapper({
    children,
    setIsConfigurationModalOpened,
    isConfigurationModalOpened,
    setIsLoading,
    numberClick,
    setNumberClick,
    setLimit,
    setIsModalLoadingOpened,
    setModalLoadingData,
}: PropsType): JSX.Element {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { defaultSetting } = useSnapshot(store);
    const { franchiseID, operatorID } = useSnapshot(globalStore);
    const uuidUser = localStorage.getItem("uuidUser");
    const handleSaveClick = () => {
        setLimit(2);
        const {
            missingFavorites,
            missingSaleSupport,
            tvaHasFavoriteWithStatusTrue,
            languageHasFavoriteWithStatusTrue,
            saleModeEmpty,
            paymentMethodEmpty,
            tvaHasFavorite,
            languageHasFavorite,
            saleSupportHasFavorite,
            saleModeHasFavorite,
        } = checkFavoriteConditions(defaultSetting, t);

        if (missingFavorites.length > 0) {
            const message = t(
                "Attention, please add at least one {{missingFavorites}} as favorite.",
                { missingFavorites: missingFavorites.join(", ") }
            );
            ErrorToast(message);
        }
        if (missingSaleSupport.length > 0) {
            const message = t(
                "Attention, a {{missingSaleSupport}} cannot be added without a sales support. Please check your sales support settings.",
                { missingSaleSupport: missingSaleSupport.join(", ") }
            );
            ErrorToast(message);
        }

        if (
            (tvaHasFavorite &&
                languageHasFavorite &&
                saleSupportHasFavorite &&
                saleModeHasFavorite &&
                !saleModeEmpty &&
                !paymentMethodEmpty) ||
            (tvaHasFavoriteWithStatusTrue === undefined &&
                !saleModeEmpty &&
                !paymentMethodEmpty) ||
            (languageHasFavoriteWithStatusTrue === undefined &&
                !saleModeEmpty &&
                !paymentMethodEmpty)
        ) {
            setIsOpen(true);
        }
    };
    async function deleteDefaultSetting() {
        const apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/deleteData?franchiseId=${franchiseID}`;
        const requestOptions = {
            method: "DELETE",
            headers: { "Content-Type": "application/json" },
        };
        try {
            const data = await fetchGlobal<any>(apiUrl, requestOptions);

            if (data.error) {
                throw Error("error");
            }

            mutate(apiUrl, data);
        } catch (e) {}
    }
    async function InsertDefaultList(franchiseId: string) {
        const url = `${process.env.REACT_APP_API_V2_URL}/settings/defaultSetting/defaultList`;
        const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                franchiseId: franchiseId,
                shopId: "0",
                uuidUser,
                operatorId: operatorID,
            }),
        };
        try {
            const data = await fetchGlobal<any>(url, requestOptions);

            if (data.error) {
            }

            mutate(url, data);
        } catch (e) {
            throw e;
        }
    }
    return (
        <React.Fragment>
            <Modal
                centered
                backdrop="static"
                fade={false}
                scrollable
                isOpen={numberClick === 0 && isConfigurationModalOpened}
                className="modal-wrapper__clz"
            >
                <ModalHeader
                    toggle={() => {
                        setIsConfigurationModalOpened(
                            !isConfigurationModalOpened
                        );
                        setNumberClick(1);
                        deleteDefaultSetting();
                        InsertDefaultList(franchiseID);
                    }}
                    className="text-uppercase"
                >
                    {t("Default Configuration Validation")}
                </ModalHeader>
                <ModalBody className="p-0">{children}</ModalBody>
                <ModalFooter>
                    <CustomSecondaryColorButton
                        className="w-20 kds_btn_validateTemplate"
                        rounded
                        variant="primary"
                        onClick={() => {
                            setIsConfigurationModalOpened(
                                !isConfigurationModalOpened
                            );
                            setNumberClick(1);
                            deleteDefaultSetting();
                            InsertDefaultList(franchiseID);
                        }}
                    >
                        {t("Annuler")}
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        className="w-20 kds_btn_validateTemplate"
                        rounded
                        variant="primary"
                        onClick={handleSaveClick}
                    >
                        {t("Save")}
                    </CustomMainColorButton>
                </ModalFooter>
            </Modal>

            {isOpen ? (
                <DefaultSettingModal
                    isOpen={isOpen}
                    setIsOpen={setIsOpen}
                    setIsConfigurationModalOpened={
                        setIsConfigurationModalOpened
                    }
                    setIsLoading={setIsLoading}
                    setIsModalLoadingOpened={setIsModalLoadingOpened}
                    setModalLoadingData={setModalLoadingData}
                />
            ) : null}
        </React.Fragment>
    );
}
